import api from './api';

/**
 * Catalog Service
 * Handles all catalog-related API calls for users
 */
const catalogService = {
    /**
     * Get my catalogs
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getMyCatalogs: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/catalogs${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get catalog by ID
     * @param {string} id - Catalog ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/user/catalogs/${id}`);
    },

    /**
     * Create new catalog
     * @param {Object} data - Catalog data
     * @returns {Promise<Object>}
     */
    create: async (data) => {
        return api.post('/user/catalogs', data);
    },

    /**
     * Update catalog
     * @param {string} id - Catalog ID
     * @param {Object} data - Updated catalog data
     * @returns {Promise<Object>}
     */
    update: async (id, data) => {
        return api.put(`/user/catalogs/${id}`, data);
    },

    /**
     * Delete catalog
     * @param {string} id - Catalog ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/user/catalogs/${id}`);
    },

    /**
     * Add offers to catalog
     * @param {string} id - Catalog ID
     * @param {string[]} offerIds - Array of offer IDs
     * @param {string} sectionId - Optional section ID to add offers to
     * @returns {Promise<Object>}
     */
    addOffers: async (id, offerIds, sectionId = null) => {
        const body = { offerIds };
        if (sectionId) body.sectionId = sectionId;
        return api.post(`/user/catalogs/${id}/offers`, body);
    },

    /**
     * Remove offers from catalog
     * @param {string} id - Catalog ID
     * @param {string[]} offerIds - Array of offer IDs
     * @param {string} sectionId - Optional section ID to remove offers from
     * @returns {Promise<Object>}
     */
    removeOffers: async (id, offerIds, sectionId = null) => {
        const body = { offerIds };
        if (sectionId) body.sectionId = sectionId;
        return api.delete(`/user/catalogs/${id}/offers`, body);
    },

    /**
     * Get public catalog by slug (no auth required)
     * @param {string} slug - Catalog slug
     * @returns {Promise<Object>}
     */
    getPublicBySlug: async (slug) => {
        return api.get(`/public/catalog/${slug}`, false);
    }
};

export default catalogService;
